import styled from 'styled-components';
import { variant } from 'styled-system';

import { theme } from '../../../common/ui/theme';
import { ProgressBarProps } from '../ProgressBar';

interface BarContainerProps {
    variant: ProgressBarProps['variant'];
}

export const BarContainer = styled.div<BarContainerProps>`
    position: relative;
    height: 4px;
    border-radius: 2px;

    ${variant({
        prop: 'variant',
        variants: {
            neutral: {
                backgroundColor: theme.colors.background.inset,
            },
            accent: {
                backgroundColor: theme.colors.accent.background,
            },
            attention: {
                backgroundColor: theme.colors.attention.background,
            },
            negative: {
                backgroundColor: theme.colors.negative.background,
            },
        },
    })}
`;
